export const TRANSACTION_TYPE_EARN_POINTS = 'earn-points';
export const TRANSACTION_TYPE_USE_VOUCHER = 'redeem-voucher';
export const TRANSACTION_TYPE_GET_VOUCHER = 'get-voucher';
export const TRANSACTION_TYPE_LIST = {
  [TRANSACTION_TYPE_EARN_POINTS]: 'Earn Points',
  [TRANSACTION_TYPE_USE_VOUCHER]: 'Use Voucher',
  [TRANSACTION_TYPE_GET_VOUCHER]: 'Get Voucher',
};

export const TRANSACTION_TYPES_CONSTANTS = {
  EARN_POINTS: 1,
  EARN_BONUS_POINTS: 2,
  EARN_POINTS_WITH_VOUCHERS: 3,
  EARN_BONUS_POINTS_WITH_VOUCHERS: 4,
  EARN_POINTS_VIA_RECEIPT: 5,
  EARN_BONUS_POINTS_VIA_RECEIPT: 6,
  GET_VOUCHER: 7,
  USE_VOUCHERS: 8,
  USED_OR_REMOVED_VOUCHERS: 9,
  ISLANDER_POINTS_REDEMPTION: 10,
};

export const TRANSACTION_FILTER_TYPE_LIST = {
  [TRANSACTION_TYPES_CONSTANTS.EARN_POINTS]: 'Earn points',
  [TRANSACTION_TYPES_CONSTANTS.EARN_POINTS_WITH_VOUCHERS]:
    'Earn points with vouchers',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS]: 'Earn bonus points',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS_WITH_VOUCHERS]:
    'Earn bonus points with vouchers',
  [TRANSACTION_TYPES_CONSTANTS.EARN_POINTS_VIA_RECEIPT]:
    'Earn points via scanned receipt',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS_VIA_RECEIPT]:
    'Earn bonus points via scanned receipt',
  [TRANSACTION_TYPES_CONSTANTS.GET_VOUCHER]: 'Get voucher',
  [TRANSACTION_TYPES_CONSTANTS.USE_VOUCHERS]: 'Used voucher',
  [TRANSACTION_TYPES_CONSTANTS.USED_OR_REMOVED_VOUCHERS]:
    'Used/Removed online voucher',
  [TRANSACTION_TYPES_CONSTANTS.ISLANDER_POINTS_REDEMPTION]:
    'Islander points redemption',
};

export const TRANSACTION_TYPES = {
  [TRANSACTION_TYPES_CONSTANTS.EARN_POINTS]:
    'Earn points at {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_POINTS_WITH_VOUCHERS]:
    'Earn points with {usedVouchers.length} voucher(s) at {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS]:
    'Earn points at {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS_WITH_VOUCHERS]:
    'Earn points with {usedVouchers.length} voucher(s) at {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_POINTS_VIA_RECEIPT]:
    'Earn points via scanned receipt of {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS_VIA_RECEIPT]:
    'Earn points via scanned receipt of {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.USE_VOUCHERS]:
    'Used {usedVouchers.length} voucher(s) at {islandPartnerName}',
  [TRANSACTION_TYPES_CONSTANTS.GET_VOUCHER]: 'Get voucher',
  [TRANSACTION_TYPES_CONSTANTS.USED_OR_REMOVED_VOUCHERS]:
    'Used/Removed online voucher',
  [TRANSACTION_TYPES_CONSTANTS.ISLANDER_POINTS_REDEMPTION]:
    'Islander points redemption at {islandPartnerName}',
};

export const TRANSACTION_TYPES_BONUS_POINTS_LABELS = {
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS]:
    'Bonus points earned from Transaction no. {workflowId}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS_WITH_VOUCHERS]:
    'Bonus points earned from Transaction no. {workflowId}',
  [TRANSACTION_TYPES_CONSTANTS.EARN_BONUS_POINTS_VIA_RECEIPT]:
    'Bonus points earned from Transaction no. {workflowId}',
};

export const NON_PARTICIPATING_OUTLET_LABEL = 'Non-participating outlet';

export const DEFAULT_PARTIAL_POINTS_CHECKBOXES = {
  pointValue: false,
  associatedPointValue: false,
};

export const DEFAULT_INITIAL_VALUES = {
  oCRHistoryReceiptId: '',
  receiptDateOfPurchase: null,
  receiptTotal: '',
  matchedMerchantID: '',
  receiptName: '',
  receiptAddress: '',
  pointValue: '',
  associatedPointValue: '',
  merchantReceiptId: '',
  receiptOperatingArea: '',
};

export const DEFAULT_ERROR_INPUT_FIELDS = {
  oCRHistoryReceiptId: '',
  receiptTotal: '',
  receiptDateOfPurchase: '',
  islanderPartnerName: '',
  matchedMerchantID: '',
  receiptName: '',
  receiptAddress: '',
  pointValue: '',
  associatedPointValue: '',
  merchantReceiptId: '',
  receiptOperatingArea: '',
};

export const DEFAULT_KEYS_SELECTED = {
  oCRHistoryReceiptId: false,
  receiptDateOfPurchase: false,
  receiptTotal: false,
  receiptPartnerAndAddress: false,
  pointValue: false,
};
